import { c as _c } from "react/compiler-runtime";
import { Drawer, LinkButton } from '@onefootprint/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useEntityId from '@/entity/hooks/use-entity-id';
import useEntityRuleSetResult from '../../../hooks/use-entity-rule-set-result';
import RuleSetResults from '../../rule-set-results';
type DetailsProps = {
  ruleSetResultId: string;
};
const Details = t0 => {
  const $ = _c(24);
  const {
    ruleSetResultId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "auditTrail.timeline.stepUpEvent.details"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const entityId = useEntityId();
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  let t2;
  if ($[1] !== entityId || $[2] !== ruleSetResultId) {
    t2 = {
      entityId,
      ruleSetResultId
    };
    $[1] = entityId;
    $[2] = ruleSetResultId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    data,
    error,
    isLoading
  } = useEntityRuleSetResult(t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex items-center justify-center mx-0.5">·</div>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setDrawerOpen(true);
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t(_temp);
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <div className="inline-flex items-center justify-center gap-1 ml-1 md:flex md:ml-0">{t3}<LinkButton onClick={t4}>{t5}</LinkButton></div>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t) {
    t7 = t(_temp2);
    $[10] = t;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      setDrawerOpen(false);
    };
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== data || $[14] !== error || $[15] !== isLoading) {
    t9 = <RuleSetResults data={data} error={error} isLoading={isLoading} />;
    $[13] = data;
    $[14] = error;
    $[15] = isLoading;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== isDrawerOpen || $[18] !== t7 || $[19] !== t9) {
    t10 = <Drawer open={isDrawerOpen} title={t7} onClose={t8}>{t9}</Drawer>;
    $[17] = isDrawerOpen;
    $[18] = t7;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t6) {
    t11 = <>{t6}{t10}</>;
    $[21] = t10;
    $[22] = t6;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
};
export default Details;
function _temp($) {
  return $.viewDetails;
}
function _temp2($_0) {
  return $_0.title;
}